const acc_ttl = Array.from(
  document.querySelectorAll(".p_faqTtl")
);

for (let i = 0; i < acc_ttl.length; i++) {
  let ttl = acc_ttl[i];
  let content = ttl.nextElementSibling;
  ttl.addEventListener("click", () => {
      ttl.classList.toggle("is_active");
      console.log(content.style.height);
      if (content.style.height) {
          content.style.height = null;
      } else {
          content.style.height = content.scrollHeight + "px";
      }
  });
}


gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll(".scroll-container").forEach((container) => {
    let line = container.querySelector(".scroll-line");
    
    gsap.to(line, {
      height: "100%", // 上から下へ伸ばす
      opacity: 1, // 透明 → 表示
      duration: 2,
      ease: "power2.out",
      scrollTrigger: {
        trigger: container,
        start: "top 80%",  // 画面の80%地点で開始
        end: "top 30%",    // 30%地点で完了
        scrub: true,       // スクロールに応じて変化
      }
    });
  });